import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { notification } from './modules/notification';
import { starWars } from './modules/starWars';
import { user } from './modules/user';
import { events } from './modules/events';
import { player } from './modules/player';
import { liveSocial } from './modules/liveSocial';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
  },
  modules: {
    notification,
    starWars,
    user,
    events,
    player,
    liveSocial,
  },
};

export default new Vuex.Store<RootState>(store);
